<!-- 移库任务单 -->
 <template>
    <div>
        <!-- 按钮组 -->
        <div class="buttons_box">
            <el-button type="primary" size="mini" class="mini_button" @click="inventoryMoveSave">保存</el-button>
            <el-button type="primary" size="mini" class="mini_button" :disabled="inventoryMoveForm.status !== '新建' " @click="inventoryMoveSaveOpTaskTrue">下发暂存</el-button>
            <el-button type="primary" size="mini" class="mini_button" :disabled="(inventoryMoveForm.status !== '') || inventoryMovePlanData.length === 0 " @click="inventoryMoveDel">删除</el-button>
            <!-- <el-button type="primary" size="mini" class="mini_button">完成</el-button>
            <el-button type="primary" size="mini" class="mini_button">车辆报备</el-button> -->
        </div>
        <!-- 表头 -->
        <el-form class="demo-form-inline inventoryMoveForm" :inline="true" ref="inventoryMoveForm" :model="inventoryMoveForm" 
        :rules="inventoryMoveFormRules" size="mini" label-width="160px">
            <el-divider content-position="left">任务信息</el-divider>
            <el-form-item label="移库单号" prop="billNo"> 
                <el-input disabled v-model="inventoryMoveForm.billNo" suffix-icon="xxxx" ></el-input>
            </el-form-item>
            <el-form-item label="移库状态" prop="status"> 
                <el-input disabled placeholder="" v-model="inventoryMoveForm.status"  suffix-icon="xxxx"></el-input>
            </el-form-item>
            <el-form-item label="单证员" prop="operator"> 
                <el-input disabled v-model="inventoryMoveForm.operator"  suffix-icon="xxxx" ></el-input>
            </el-form-item> 
            <el-form-item label="创建日期" prop="createDate"> 
                <el-date-picker disabled v-model="inventoryMoveForm.createDate" type="date" value-format="yyyy-MM-dd"  placeholder="" style="width:100%"> </el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="货主单位" prop="ownerName">
                <el-input disabled v-model="inventoryMoveForm.ownerName"  suffix-icon="xxxx" ></el-input>
            </el-form-item> -->
            <el-form-item label="仓库" prop="ckName">
                <el-input disabled v-model="inventoryMoveForm.ckName"  suffix-icon="xxxx" ></el-input>
            </el-form-item>
            <el-form-item label="提单号" prop="blNo">
                <el-input disabled v-model="inventoryMoveForm.blNo"  suffix-icon="xxxx" ></el-input>
            </el-form-item>
            <el-form-item label="货物名称" prop="goodsName">
                <el-input disabled v-model="inventoryMoveForm.goodsName"  suffix-icon="xxxx" ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="note"> 
                <el-input placeholder="请输入备注" v-model="inventoryMoveForm.note" suffix-icon="xxxx" style="width: 550px;"></el-input>
            </el-form-item>
        </el-form>
        <el-divider content-position="left">计划信息</el-divider>
        <div class="buttons_box" style="justify-content: space-between;">
            <div>
                <el-button type="primary":disabled="inventoryMoveForm.id && inventoryMoveForm.status !== '新建' " size="mini" 
                class="mini_button" @click="batchDeleteMovePlan">删除</el-button>
            </div>
            <vxe-toolbar ref="toolbarRef"  custom ></vxe-toolbar>
        </div>
        <vxe-table id="inventoryMoveTable"  size="mini" ref="inventoryMoveTable" :data="inventoryMovePlanData" border stripe
            :custom-config="inventoryMovePlanCustomConfig"  header-align="center"  :columns="inventoryMovePlanColumns" max-height="250"
            :column-config="{resizable: true,sortable: true,drag:true}" :radio-config="{labelField: '', highlight: true}"
            :row-config="{ isCurrent: true,isHover: true}"
            :checkbox-config="{labelField: '', highlight: true}" @checkbox-change="movePlanRowsCheckbox"  @checkbox-all="movePlanRowsCheckbox" >
            <vxe-column type="checkbox" fixed="left" width="50"></vxe-column>
            <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column v-for="column in inventoryMovePlanColumns" :field="column.field" :title="column.title" sortable >
                     <template #default="{ row, column }">
                        <!-- <span v-if="column.field === 'decCurrency'"> 
                            {{ row.decCurrencyName }}
                        </span>
                        <span v-else-if="column.field === 'originCountry'"> 
                            {{ row.originCountryName }}
                        </span>
                        <span v-else-if="column.field === 'lawUnitFirst'"> 
                            {{ row.lawUnitFirstName }}
                        </span>
                        <span v-else-if="column.field === 'lawUnitSecond'"> 
                            {{ row. lawUnitSecondName }}
                        </span>
                        <span v-else-if="column.field === 'decUnit'"> 
                            {{ row. decUnitName }}
                        </span> -->
                        <!-- <span v-else> {{ row[column.field] }} </span> -->
                        <span > {{ row[column.field] }} </span>
                    </template>
                </vxe-column>
                 <!-- <vxe-column title="操作" width="80" align="center" fixed="right" >
                    <template #default="{ row }">
                        <el-button type="text" size="mini" class="mini_button" @click="deleteInventoryPlan(row)"
                        :disabled="inventoryMoveForm.status !== '新建' ">删除</el-button>
                    </template>
                </vxe-column> -->
        </vxe-table>
        <el-divider content-position="left" >库存信息</el-divider>
        <el-form class=" inventorySeachForm demo-form-inline" :inline="true" ref="inventorySeachForm" :model="inventorySeachForm" size="mini" label-width="80px"
        :rules="inventorySeachFormRules" >
            <el-form-item label="货物名称" prop="goodsName"> 
                <el-select class="width_100" filterable :default-first-option="true" remote :remote-method="getGoodsList"
                    placeholder="请选择货物名称" v-model="inventorySeachForm.goodsName" clearable>
                    <el-option v-for="item in goodsList" :key="item.id" :label="item.goodsName" :value="item.goodsName">
                        <span class="margin_right_20">{{ item.goodsName }}</span>
                        <span class="margin_right_20">{{ item.goodsType }}</span> 
                        <span >{{ item.hsCode }}</span> 
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="货主" prop="ownerName"> 
                <el-select filterable placeholder="请选择货主" v-model="inventorySeachForm.ownerName" clearable>
                    <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="提单号" prop="blNo"> 
                <el-input placeholder="请输入提单号" v-model="inventorySeachForm.blNo" clearable ></el-input>
            </el-form-item>
            <el-form-item label="箱号" prop="boxNo"> 
                <el-input  v-model="inventorySeachForm.boxNo" placeholder="请输入提单号" clearable ></el-input>
            </el-form-item>
            <el-form-item label="仓库" prop="ckName"> 
                <el-select clearable placeholder="请选择仓库" v-model="inventorySeachForm.ckName" @change="changeCkName">
                    <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item" > </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="库区" prop="place"> 
                <el-select class="width_100" @change="placeEnter" v-model="inventorySeachForm.place" placeholder="请选择库区" clearable filterable>
                    <el-option v-for="item in placeList"  :key="item.name" :label="item.name " :value="item.name + '-' + item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="库位" prop="location">
                <el-select class="width_100" filterable v-model="inventorySeachForm.location" placeholder="请选择库位" clearable>
                    <el-option v-for="item in locationList"  :key="item.locationName" :label="item.locationName " :value="item.locationName">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="" prop=""> 
                <el-button type="primary" size="mini" @click="inventorySeach">搜索</el-button>
                <el-button type="primary" size="mini" :disabled="inventoryMoveForm.id && inventoryMoveForm.status !== '新建' " @click="batchAddMovePlan">批量添加计划</el-button>
            </el-form-item>
        </el-form>
        <vxe-table id="inventoryTable" size="mini" ref="inventoryTable" :data="inventoryList" border stripe max-height="250"
            :row-config="{ isCurrent: true,isHover: true}" :radio-config="{labelField: '', highlight: true}" 
            @checkbox-all="inventoryTableRowsCheckbox" @checkbox-change="inventoryTableRowsCheckbox" 
            :checkbox-config="{labelField: '', highlight: true}" >
            <vxe-column type="checkbox" fixed="left" width="50"></vxe-column>
            <vxe-column type="seq" width="50" fixed="left"></vxe-column>
            <vxe-column field="blNo" title="提单号" width="100" fixed="left"></vxe-column>
            <vxe-column field="goodsName" title="货物名称" width="180" fixed="left"></vxe-column>
            <vxe-column field="ownerName" title="货主单位" width="180" fixed="left"></vxe-column>
            <vxe-column field="customer" title="委托单位" width="180"></vxe-column>
            <vxe-column field="goodsType" title="货物分类" width="80"></vxe-column>
            <vxe-column field="isBonded" title="保税类型" width="70"></vxe-column>
            <vxe-column field="spec" title="规格型号" min-width="150"></vxe-column>
            <vxe-column field="hsCode" title="海关编码" width="100"></vxe-column>
            <vxe-column field="invDecNo" title="核注清单号" width="140"></vxe-column>
            <vxe-column field="cusDeclNo" title="报关单号" width="140"></vxe-column>
            <vxe-column field="skuNo" title="商品料号" width="130"></vxe-column>
            <vxe-column field="handbook" title="账册编号" width="110"></vxe-column>
            <vxe-column field="createDate" title="入库日期" width="100"></vxe-column>
            <vxe-column field="ckName" title="仓库" width="100"></vxe-column>
            <vxe-column field="place" title="库区" width="100"></vxe-column>
            <vxe-column field="location" title="库位" width="100"></vxe-column>
            <vxe-column field="totalNetWeight" title="净重" width="100"></vxe-column>
            <vxe-column field="decUnitName" title="申报单位" width="100"></vxe-column>
            <vxe-column field="totalDecNum" title="申报数量" width="100"></vxe-column>
            <vxe-column field="totalQty1" title="件数1" width="100"></vxe-column>
            <vxe-column field="qty1UnitName" title="件数1单位" width="100"></vxe-column>
            <vxe-column field="totalQty2" title="件数2" width="100"></vxe-column>
            <vxe-column field="qty2UnitName" title="件数2单位" width="100"></vxe-column>
            <vxe-column field="lawUnitFirstName" title="法定第一单位" width="100"></vxe-column>
            <vxe-column field="totalFirstNum" title="法定第一数量" width="100"></vxe-column>
            <vxe-column field="lawUnitSecond" title="法定第二单位" width="100"></vxe-column>
            <vxe-column field="totalSecondNum" title="法定第二数量" width="100"></vxe-column>
            <vxe-column field="note" title="备注" width="100"></vxe-column>
            <!-- 操作列 -->
             <vxe-column title="操作" width="70" fixed="right">
                <template v-slot="scope"> 
                    <el-button type="primary" size="mini" @click="AddMovePlan(scope.row)"
                    :disabled="inventoryMoveForm.id && inventoryMoveForm.status !== '新建' ">移库</el-button>
                </template>
             </vxe-column>
        </vxe-table>
        <!-- 下发暂存作业表 -->
         <el-divider content-position="left" >作业信息</el-divider>
        <!-- 作业信息列表 -->
        <vxe-table id="IssueGoodsTable"  size="mini" ref="IssueGoodsTable" :data="IssueGoodsData" border stripe
            :column-config="{resizable: true,sortable: true}"  header-align="center" :row-config="{ isHover: true}" 
            :radio-config="{labelField: '', highlight: true}" style="margin-top: 0px;" min-height="0"  max-height="400">
            <!-- <vxe-column type="checkbox" title="" fixed="left" width="50"></vxe-column>     -->
            <vxe-column type="seq" width="50" fixed="left"></vxe-column>
            <vxe-column field="rowStatus" title="状态" sortable width="70"></vxe-column>
            <vxe-column field="taskNo" title="作业任务单号" min-width="130">
                <template #default="{ row } ">
                    <span v-if="row.rowStatus === '完成'" @click="getCompleteDetails(row)">
                        <el-link  type="primary"  style="font-size: 12px;">{{row.taskNo}}</el-link>
                    </span>
                    <span v-else> {{ row.taskNo }} </span>
                </template>
            </vxe-column>
            <vxe-column field="blNo" title="提单号" min-width="120"></vxe-column>
            <vxe-column field="storekeeper" title="理货员"  min-width="100"></vxe-column>
            <vxe-column field="goodsName" title="货物名称"  min-width="100"></vxe-column>
            <!-- <vxe-column field="spec" title="规格型号"  width="100"></vxe-column> -->
            <vxe-column field="ckName" title="仓库" min-width="90"></vxe-column>
            <vxe-column field="driver" title="司机" min-width="80"></vxe-column>
            <vxe-column field="truckNo" title="车牌" min-width="80"></vxe-column>
            <vxe-column field="qty1" title="总件数1" min-width="80"></vxe-column>
            <vxe-column field="netWeight" title="总净重(KG)" min-width="80"></vxe-column>
            <!-- <vxe-column field="itemNo" title="项号" min-width="80"></vxe-column> -->
            <vxe-column field="note" title="备注" min-width="120"></vxe-column>
            <vxe-column field="opNote" title="现场备注" min-width="120"></vxe-column>
            <vxe-column field="createTime" title="创建时间" sortable  width="130"  :formatter="({ cellValue }) => cellValue ? cellValue.split('T')[0] + '  ' +  cellValue.split('T')[1] : ''" ></vxe-column>
            <vxe-column field="completeTime" title="完成时间" sortable  width="130"  :formatter="({ cellValue }) => cellValue ? cellValue.split('T')[0] + '  ' +  cellValue.split('T')[1] : ''" ></vxe-column>
            <vxe-column title="操作" fixed="right" width="160">
                <template #default="{ row }">
                    <el-button type="text" :disabled=" (row.rowStatus !== '暂存')" size="mini" class="mini_button_text" @click="delIssueRows(row)">删除</el-button>
                    <el-button type="text" :disabled=" (row.rowStatus !== '暂存') " size="mini" class="mini_button_text" @click="IssueRows(row)">下发</el-button>
                    <el-button type="text" :disabled=" (row.rowStatus === '已下发' ? false : true) "  size="mini" class="mini_button_text" @click="completeRows(row)">完成</el-button>
                    <el-dropdown trigger="click" @command="(command) => report(command, row)">
                        <span class="el-dropdown-link">
                            <el-button type="text" size="mini" class="mini_button_text" >打印</el-button>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="存货卡_有标识_保税">存货卡_有标识_保税</el-dropdown-item>
                            <el-dropdown-item command="存货卡_有标识_非保税">存货卡_有标识_非保税</el-dropdown-item>
                            <el-dropdown-item command="存货卡_无标识_保税">存货卡_无标识_保税</el-dropdown-item>
                            <el-dropdown-item command="存货卡_无标识_非保税">存货卡_无标识_非保税</el-dropdown-item>
                            <el-dropdown-item command="存货卡_建发">存货卡_建发</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </vxe-column>
        </vxe-table>
        <div style="width: 100%;height: 200px;"></div>
        <!-- 添加移库计划弹出框 -->
        <el-dialog title="移库计划信息" width="75%" :visible.sync="inventoryMoveVisible" :before-close="inventoryMoveClose" v-dialogDrag
            :close-on-click-modal="false">
            <el-descriptions title="" :column="4" size="medium">
                <el-descriptions-item label="保税类型">{{ inventoryPlanRows.isBonded }}</el-descriptions-item>
                <el-descriptions-item label="货物名称">{{ inventoryPlanRows.goodsName }}</el-descriptions-item>
                <el-descriptions-item :span="2" label="规格型号">{{ inventoryPlanRows.spec }}</el-descriptions-item>
                <el-descriptions-item label="货主单位">{{ inventoryPlanRows.ownerName }}</el-descriptions-item>
                <el-descriptions-item label="提单号">{{ inventoryPlanRows.blNo }}</el-descriptions-item>
                <el-descriptions-item label="报关单号">{{ inventoryPlanRows.cusDeclNo }}</el-descriptions-item>
                <el-descriptions-item label="核注清单号">{{ inventoryPlanRows.invDecNo }}</el-descriptions-item>
                <el-descriptions-item label="仓库">{{ inventoryPlanRows.ckName }} - {{ inventoryPlanRows.place }} - {{ inventoryPlanRows.location }}</el-descriptions-item>
                <el-descriptions-item label="净重(KG)">{{ inventoryPlanRows.totalNetWeight }}</el-descriptions-item>
                <el-descriptions-item label="申报数量">{{ inventoryPlanRows.totalDecNum }} {{ inventoryPlanRows.decUnitName }}</el-descriptions-item>
                <el-descriptions-item label="申报金额">{{ inventoryPlanRows.totalDecAmount }} {{ inventoryPlanRows.decCurrency }}</el-descriptions-item>
                <el-descriptions-item label="件数1">{{ inventoryPlanRows.totalQty1 }} {{ inventoryPlanRows.qty1UnitName }}</el-descriptions-item>
                <el-descriptions-item label="件数2">{{ inventoryPlanRows.totalQty2 }} {{ inventoryPlanRows.qty2UnitName }}</el-descriptions-item>
                <el-descriptions-item label="法定第一数量">{{ inventoryPlanRows.totalFirstNum }} {{ inventoryPlanRows.lawUnitFirstName }}</el-descriptions-item>
                <el-descriptions-item label="法定第二数量">{{ inventoryPlanRows.totalSecondNum }} {{ inventoryPlanRows.lawUnitSecondName }}</el-descriptions-item>
            </el-descriptions>
             <el-form class="demo-form-inline" :inline="true" ref="inventoryMoveAddForm" :model="inventoryMoveAddForm" size="mini" label-width="120px"
            :rules="inventoryMoveAddRules">
                <el-form-item label="仓库" prop="newckName"> 
                    <el-select class="width_100" @change="cknameAddEnter" v-model="inventoryMoveAddForm.newckName" placeholder="请选择仓库" clearable>
                        <el-option v-for="item in ckNameList"  :key="item" :label="item" :value="item" >
                        </el-option>
                    </el-select>
                </el-form-item> 
                <el-form-item label="库区" prop="newPlace"> 
                    <el-select class="width_100" @change="placeAddEnter" v-model="inventoryMoveAddForm.newPlace" placeholder="请选择库区" clearable>
                        <el-option v-for="item in placeAddList"  :key="item.name" :label="item.name " :value="item.name + '-' + item.id">
                        </el-option>
                    </el-select>
                </el-form-item> 
                <el-form-item label="库位" prop="newLocation"> 
                    <el-select class="width_100" filterable v-model="inventoryMoveAddForm.newLocation" placeholder="请选择库位" clearable>
                        <el-option v-for="item in locationAddList"  :key="item.locationName" :label="item.locationName " :value="item.locationName">
                        </el-option>
                    </el-select>
                </el-form-item> 
                <el-form-item label="件数1" prop="qty1"> 
                    <el-input  v-model="inventoryMoveAddForm.qty1"  suffix-icon="xxxx" @blur="qty1Blur"></el-input>
                </el-form-item>
                <el-form-item label="件数2" :prop="inventoryPlanRows.totalQty2? 'qty2':''" > 
                    <el-input :disabled="!inventoryPlanRows.totalQty2" v-model="inventoryMoveAddForm.qty2"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="净重(KG)" prop="netWeight"> 
                    <el-input v-model="inventoryMoveAddForm.netWeight"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="申报数量" :prop="inventoryPlanRows.totalDecNum? 'decNum':''" > 
                    <el-input :disabled="!inventoryPlanRows.totalDecNum" v-model="inventoryMoveAddForm.decNum"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="法定第一数量" :prop="inventoryPlanRows.totalFirstNum? 'firstNum':''"> 
                    <el-input :disabled="!inventoryPlanRows.totalFirstNum" v-model="inventoryMoveAddForm.firstNum"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="法定第二数量" :prop="inventoryPlanRows.totalSecondNum? 'secondNum':''" > 
                    <el-input :disabled="!inventoryPlanRows.totalSecondNum" v-model="inventoryMoveAddForm.secondNum"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="申报金额" :prop="inventoryPlanRows.totalDecAmount? 'decAmount':''"> 
                    <el-input :disabled="!inventoryPlanRows.totalDecAmount" v-model="inventoryMoveAddForm.decAmount"  suffix-icon="xxxx"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="saveAddInventoryMovePlan">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 下发弹窗 -->
        <el-dialog title="移库下发暂存作业" width="75%" :visible.sync="inventoryMoveSaveOpTaskVisible" :before-close="inventoryMoveSaveOpTaskClose" v-dialogDrag
            :close-on-click-modal="false">
            <el-form class="demo-form-inline" :inline="true" ref="inventoryMoveSaveOpTaskForm" :model="inventoryMoveSaveOpTaskForm" size="mini" label-width="120px"
            :rules="inventoryMoveSaveOpTaskRules">
                <el-form-item label="理货员" prop="storekeeper"> 
                    <el-select class="width_100" v-model="inventoryMoveSaveOpTaskForm.storekeeper" placeholder="请选择理货员" clearable>
                        <el-option v-for="item in storekeeperList"  :key="item.userName" :label="item.userName " :value="item.userName">
                        </el-option>
                    </el-select>
                </el-form-item> 
                <el-form-item label="备注" prop="note"> 
                    <el-input v-model="inventoryMoveSaveOpTaskForm.note" style="width:800px" placeholder="请输入备注"></el-input>
                </el-form-item> 
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="inventoryMoveSaveOpTaskClose">取 消</el-button>
                <el-button size="mini" type="primary" @click="inventoryMoveSaveOpTask">下发暂存</el-button>
            </span>
        </el-dialog>
        <!-- 批量添加计划弹窗 -->
         <el-dialog title="移库计划信息" width="75%" :visible.sync="inventoryMoveBatchVisible" :before-close="inventoryMoveBatchClose" v-dialogDrag
            :close-on-click-modal="false">
             <el-form class="demo-form-inline" :inline="true" ref="inventoryMoveAddBatchForm" :model="inventoryMoveAddBatchForm" size="mini" label-width="120px"
            :rules="inventoryMoveAddBatchRules">
                <el-form-item label="仓库" prop="newckName"> 
                    <el-select class="width_100" @change="cknameAddBatchEnter" v-model="inventoryMoveAddBatchForm.newckName" placeholder="请选择仓库" clearable>
                        <el-option v-for="item in ckNameList"  :key="item" :label="item" :value="item" >
                        </el-option>
                    </el-select>
                </el-form-item> 
                <el-form-item label="库区" prop="newPlace"> 
                    <el-select class="width_100" @change="placeAddBatchEnter" v-model="inventoryMoveAddBatchForm.newPlace" placeholder="请选择库区" clearable>
                        <el-option v-for="item in placeAddList"  :key="item.name" :label="item.name " :value="item.name + '-' + item.id">
                        </el-option>
                    </el-select>
                </el-form-item> 
                <el-form-item label="库位" prop="newLocation"> 
                    <el-select class="width_100" filterable v-model="inventoryMoveAddBatchForm.newLocation" placeholder="请选择库位" clearable>
                        <el-option v-for="item in locationAddList"  :key="item.locationName" :label="item.locationName " :value="item.locationName">
                        </el-option>
                    </el-select>
                </el-form-item> 
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="saveBatchAddInventoryMovePlan">确 定</el-button>
            </span>
        </el-dialog>
        <viewCompletework :viewCompleteworkVisible="viewCompleteworkVisible" :completeworkRow="completeworkRow"
        @viewCompleteworkClose="viewCompleteworkClose"></viewCompletework>
    </div>
</template>
<script>
import userProfile from '@/mixins/userProfile.js'
import basicData from '@/config/basicData.js'
import viewCompletework from '@/components/wms/viewCompletework.vue'
import AEObasicData from '@/config/AEObasicData.js'
import { findNameByCode, findCodeByName } from '@/utils/dict.js'
import clean from 'lodash-clean';
import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate, webapp_ws_ajax_together } from "../../utils/reports/grwebapp";
// 提前把所有 Logo 转成 base64 引入
export default {
    name: 'inventoryMove',
    mixins: [userProfile],
    components:{
        viewCompletework,

    },
    watch: { 
        // 根据仓库不同切换不同的理货员
        'inventoryMoveForm.ckName':{
            handler(newVal, oldVal) {
               this.wmsMobileGetUserList(newVal)
            },
            immediate: true, // 是否立即执行一次
            deep: false // 是否深度监听
        },
    },
    data() {
        // 自定义验证函数  件数1移库计划
        const validateQty1 = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入件数1")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventoryPlanRows.totalQty1) {
                return callback(new Error(`件数1不能超过 ${this.inventoryPlanRows.totalQty1}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  件数2出库计划
        const validateQty2 = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入件数2")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventoryPlanRows.totalQty2) {
                return callback(new Error(`件数2不能超过 ${this.inventoryPlanRows.totalQty2}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  净重出库计划
        const validateNetWeight = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入净重")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventoryPlanRows.totalNetWeight) {
                return callback(new Error(`净重不能超过 ${this.inventoryPlanRows.totalNetWeight}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  申报数量出库计划
        const validateDecNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入申报数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventoryPlanRows.totalDecNum) {
                return callback(new Error(`申报数量不能超过 ${this.inventoryPlanRows.totalDecNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  法1出库计划
        const validateFirstNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入法定第一数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventoryPlanRows.totalFirstNum) {
                return callback(new Error(`法定第一数量不能超过 ${this.inventoryPlanRows.totalFirstNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  法2出库计划
        const validateSecondNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入法定第二数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventoryPlanRows.totalSecondNum) {
                return callback(new Error(`法定第二数量不能超过 ${this.inventoryPlanRows.totalSecondNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  申报金额出库计划
        const validateDecAmount = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入申报金额")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.inventoryPlanRows.totalDecAmount) {
                return callback(new Error(`申报金额不能超过 ${this.inventoryPlanRows.totalDecAmount}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        return{
            inventoryMovePlanCustomConfig:null, // 自定义表格配置
            hasHandledToken:false,
            customerList:[], // 货主列表
            goodsList:[], // 货物名称列表
            ckNameList:[], // 获取仓库列表
            placeList:[], // 库区列表
            locationList:[], // 库位列表
            inventoryList:[], // 库存列表
            storekeeperList:[], // 理货员列表
            inventoryMoveVisible:false, // 移库弹窗
            inventoryMoveBatchVisible:false, // 批量添加计划弹窗
            inventoryMoveForm:{
                operator:'', // 创建人
                opType:'移库',
                note:'',
                billNo:'',
                status:'',
                createDate:'',
                ownerName:'',
                ckName:'',
                blNo:'',
                goodsName:''
            },
            inventoryMoveAddBatchForm:{
                newckName:'',
                newPlace:'', 
                newLocation:'',
            },
            inventoryMoveFormRules:{
            },
            inventoryMovePlanData:[], // 移库计划列表
            inventoryMovePlanRows:{}, // 计划选中行
            inventoryPlanRows:{}, // 库存选中行
            placeAddList:[], // 添加移库中的库区列表
            locationAddList:[], // 添加移库中的库位列表
            inventoryTableCheckbox:[], // 多选库存表格
            movePlanCheckbox:[], // 计划信息多选表格
            inventorySeachForm:{ // 查询库存表单
                goodsName:'',
                ownerName:'',
                blNo:'',
                ckName:'',
                place:'',
                location:'',
                boxNo:'',
            },
            inventoryMoveSaveOpTaskVisible:false, // 保存移库任务弹窗显隐
            inventoryMoveSaveOpTaskForm:{
                storekeeper:'',
                note:'',
            }, // 移库下发暂存任务
            IssueGoodsData:[], // 下发作业列表
            unitList:AEObasicData.CUS_UNIT, // 计量单位
            inventorySeachFormRules:{
                // goodsName:[
                //     { required: true, message: '请选择货物名称', trigger: 'blur' },
                // ],
            }, // 搜索库存表单规则
            inventoryMoveAddForm:{ // 添加移库弹窗中表单
                newckName:'',
                newPlace:'', 
                newLocation:'',
            },
            // 添加移库表单规则
            inventoryMoveAddRules:{
                newckName:[
                    { required: true, message: '请选择仓库', trigger: 'blur' },
                ],
                newPlace:[
                    { required: true, message: '请选择库区', trigger: 'blur' },
                ],
                newLocation:[
                    { required: true, message: '请选择库位', trigger: 'blur' },
                ],
                qty1:[
                    { required: true, message: '请输入件数1', trigger: 'blur' },
                    { validator: validateQty1, trigger: "blur" }
                ],
                qty2:[
                    { required: true, message: '请输入件数2', trigger: 'blur' },
                    { validator: validateQty2, trigger: "blur" }
                ],
                netWeight:[
                    { required: true, message: '请输入净重', trigger: 'blur' },
                    { validator: validateNetWeight, trigger: "blur" }
                ],
                decNum:[
                    { required: true, message: '请输入申报数量', trigger: 'blur' },
                    { validator: validateDecNum, trigger: "blur" }
                ],
                firstNum:[
                    { required: true, message: '请输入法定第一数量', trigger: 'blur' },
                    { validator: validateFirstNum, trigger: "blur" }
                ],
                secondNum:[
                    { required: true, message: '请输入法定第二数量', trigger: 'blur' },
                    { validator: validateSecondNum, trigger: "blur" }
                ],
                decAmount:[
                    { required: true, message: '请输入申报金额', trigger: 'blur' },
                    { validator: validateDecAmount, trigger: "blur" }
                ],
            },
            inventoryMoveAddBatchRules:{
                newckName:[
                    { required: true, message: '请选择仓库', trigger: 'blur' },
                ],
                newPlace:[
                    { required: true, message: '请选择库区', trigger: 'blur' },
                ],
                newLocation:[
                    { required: true, message: '请选择库位', trigger: 'blur' },
                ],
            },
            viewCompleteworkVisible:false, // 查看完成作业弹窗
            completeworkRow:{}, // 完成的row信息
            inventoryMoveSaveOpTaskRules:{
                storekeeper:[
                    { required: true, message: '请选择理货员', trigger: 'change' }
                ],
            }, // 移库下发暂存验证规则
            //实际使用的列配置（从本地存储恢复或用默认）
            inventoryMovePlanColumns:[],
        }
    },
    created() {
        window.addEventListener('message', (event) => {
            if (event.source === window) {
                // 当页面消息来自自己时（F5刷新）并且hasHandledToken为false时（证明是第一次执行，保证接口只调用一次）
                if(localStorage.getItem('id') && !this.hasHandledToken){
                    this.inventoryMovePlanCustomConfig = this.customConfig
                    this.getCustomerList()
                    this.getGoodsList()
                    this.getckNameList()
                    // 查询详情
                    this.getWMSMoveDetail(localStorage.getItem('id'))
                }
                return false
            }
            // 父页面消息
            this.handleMessage(event);
        });
    },
    mounted() {
        // 获取当前日期
         this.inventoryMoveForm.createDate = new Date().toISOString().split('T')[0] // 格式化为 "2026-02-03"
         window.addEventListener('beforeunload', this.notifyParentBeforeUnload);
    },
    methods: {
        // 接收父窗口的消息
        handleMessage(event) {
            if (event.data.type === 'SET_TOKEN' && !this.hasHandledToken) {
                this.hasHandledToken = true;
                localStorage.setItem('token', event.data.token);
                localStorage.setItem('name', event.data.name);
                localStorage.setItem('parentOrigin', event.data.parentOrigin);
                // 向父窗口发送消息
                event.source.postMessage(
                    { type: 'TOKEN_RECEIVED' },
                    event.origin
                );
                Promise.resolve().then(() => {
                    this.inventoryMovePlanCustomConfig = this.customConfig
                    this.getCustomerList()
                    this.getckNameList()
                    if(event.data.id !== ''){
                        localStorage.setItem('id', event.data.id);
                        this.getWMSMoveDetail(localStorage.getItem('id'))
                    }else{
                        this.inventoryMoveForm.operator = event.data.name
                    }
                })
            }
        },
        // 获取货主列表
        getCustomerList(){
            this.$api.getCompanyList(  ).then(res =>{
                this.customerList = res.tableData
            })
        },
        // 获取货物计划列表
        getGoodsList(value){
            this.$api.getInUseListBy({param:value} ).then(res =>{
            // this.$api.wmsgetListBy( 1,100,{param:value} ).then(res =>{
                this.goodsList = res.tableData
            })
        }, 
        // 获取理货员列表
        async wmsMobileGetUserList(ckName){
            try{
                const res = await this.$api.wmsMobileGetUserList(1,100, { ckName:ckName,isTally:1})
                const data = res || {}
                // 兼容分页返回
                const list = Array.isArray(data) ? data : data.records || data.tableData || []
                // 拿到数据再赋值！
                this.storekeeperList = list
                
            }catch(e){
                console.error('获取失败',e)
                this.storekeeperList = []
            }
        },
        // 获取仓库
        getckNameList(){
            this.$api.getCkNamesBy(  ).then(res =>{
                this.ckNameList = res
                this.inventorySeachForm.ckName = this.ckNameList[0]
            })
        },
        // 获取库区列表
        getStore(){
            this.$api.getStore( this.inventorySeachForm.ckName ).then(res =>{
                this.placeList = res
            })
        },
        // 查询库位列表
        getLocation(id){
            this.$api.getLocation( id ).then(res =>{
                this.locationList = res
            })
        },
        // 保存表头
        async inventoryMoveSave(){
            // 如果有id则新增，有则修改
            if(this.inventoryMoveForm.billNo && this.inventoryMoveForm.billNo !== '' ){
                await this.$api.wmsUpdateStockMoveHead( this.inventoryMoveForm )
                await this.getWMSMoveDetail(res);
                this.$message.success('保存成功');
            } else{
                const res = await this.$api.wmsAddStockMoveHead( this.inventoryMoveForm )
                if (localStorage.getItem('id')) {
                    localStorage.setItem('id', res);
                }
                await this.getWMSMoveDetail(res);
                // 等待查询详情完成
                this.$message.success('保存成功');
            }
        },
        // 查询移库任务单详情
        getWMSMoveDetail(id){
            this.$api.wmsGetStockMoveHead( id ).then(res =>{
                this.inventoryMoveForm = res.moveMain
                this.inventoryMovePlanColumns = res.moveSub.columns
                this.inventoryMovePlanData = res.moveSub.tableData
            })
            // 查询移库计划单
            this.wmsGetOpsBySubId(id)
        },
        // 查询库存
        inventorySeach(){
            // 显示必须有一个查询条件
            if(this.inventorySeachForm.goodsName === '' && this.inventorySeachForm.ownerName === '' && this.inventorySeachForm.blNo === '' &&
                this.inventorySeachForm.ckName === '' && this.inventorySeachForm.place === '' && this.inventorySeachForm.location === '' &&
                this.inventorySeachForm.boxNo === ''){
                    this.$message.error('至少有一个查询条件');
                    return false
            }
            this.$refs.inventorySeachForm.validate(async (valid) => {
                if (valid) {
                    this.$api.wmsGetStockList( this.inventorySeachForm ,1000,1).then(res =>{
                        this.inventoryList = res.records
                    })
                }
            })
        },
        // 选择仓库时
        changeCkName(){
            if( this.inventorySeachForm.ckName){
                this.inventorySeachForm.place = ''
                this.inventorySeachForm.location = ''
                this.getStore()
            }
        },
        // 根据库区查询库位列表
        placeEnter(value){
            if(value === ''){
                this.inventorySeachForm.place = ''
                this.locationList = []
            }else{
                const item  = value.split('-')
                this.inventorySeachForm.place = item[0]
                this.getLocation(item[1])
            }
            this.inventorySeachForm.location = ''
        },
        // 添加移库计划
        AddMovePlan(row){
            this.inventoryPlanRows = row
            // 搜索当前仓库下库区
            this.$api.getStore( this.inventoryPlanRows.ckName ).then(res =>{
                this.placeAddList = res
                // 数量赋值
                this.inventoryMoveAddForm = {
                    newckName:this.inventoryPlanRows.ckName,
                    newPlace:'',
                    newLocation: '',
                    qty1: this.inventoryPlanRows.totalQty1,
                    qty2:   this.inventoryPlanRows.totalQty2,
                    netWeight:  this.inventoryPlanRows.totalNetWeight,
                    decNum: this.inventoryPlanRows.totalDecNum,
                    decAmount:  this.inventoryPlanRows.totalDecAmount,
                    firstNum: this.inventoryPlanRows.totalFirstNum,
                    secondNum: this.inventoryPlanRows.totalSecondNum,
                }
                this.inventoryMoveVisible = true
            })
        },
        // 根据仓库查询库区
        cknameAddEnter(value){
            if(value === ''){
                this.placeAddList = []
            }else{
                // 查库区
                this.$api.getStore( this.inventoryMoveAddForm.newckName ).then(res =>{
                    this.placeAddList = res
                })
            }
            this.inventoryMoveAddForm.newPlace = ''
            this.inventoryMoveAddForm.newLocation = ''
            this.locationAddList = []
        },
        cknameAddBatchEnter(value){
            if(value === ''){
                this.placeAddList = []
            }else{
                // 查库区
                this.$api.getStore( this.inventoryMoveAddBatchForm.newckName ).then(res =>{
                    this.placeAddList = res
                })
            }
            this.inventoryMoveAddBatchForm.newPlace = ''
            this.inventoryMoveAddBatchForm.newLocation = ''
            this.locationAddList = []
        },
        // 在添加移库弹窗中选择库区
        placeAddEnter(value){
            if(value === ''){
                this.inventoryMoveAddForm.newPlace = ''
                // this.placeAddList = []
                this.locationAddList = []
            }else{
                const item  = value.split('-')
                this.inventoryMoveAddForm.newPlace = item[0]
                this.$api.getLocation( item[1] ).then(res =>{
                    this.locationAddList = res
                })
            }
            this.inventoryMoveAddForm.newLocation = ''
        },
        placeAddBatchEnter(value){
            if(value === ''){
                this.inventoryMoveAddBatchForm.newPlace = ''
                // this.placeAddList = []
                this.locationAddList = []
            }else{
                const item  = value.split('-')
                this.inventoryMoveAddBatchForm.newPlace = item[0]
                this.$api.getLocation( item[1] ).then(res =>{
                    this.locationAddList = res
                })
            }
            this.inventoryMoveAddBatchForm.newLocation = ''
        },
        // 关闭添加移库弹窗
        inventoryMoveClose(){
            this.inventoryMoveVisible = false
            this.inventoryMoveAddForm = {
                newckName:'',
                newPlace:'', 
                newLocation:'',
            }
        },
        // 当添加移库计划中的件数1发生改变时，同时改件数2，净重，申报数量，金额
        qty1Blur(){
            // 净重
            this.inventoryMoveAddForm.netWeight = this.calculateAllPlanFields(this.inventoryPlanRows.totalNetWeight,this.inventoryPlanRows.totalQty1,this.inventoryMoveAddForm.qty1)
            this.inventoryMoveAddForm.qty2 = this.calculateAllPlanFields(this.inventoryPlanRows.totalQty2,this.inventoryPlanRows.totalQty1,this.inventoryMoveAddForm.qty1)
            this.inventoryMoveAddForm.decNum = this.calculateAllPlanFields(this.inventoryPlanRows.totalDecNum,this.inventoryPlanRows.totalQty1,this.inventoryMoveAddForm.qty1)
            this.inventoryMoveAddForm.decAmount = this.calculateAllPlanFields(this.inventoryPlanRows.totalDecAmount,this.inventoryPlanRows.totalQty1,this.inventoryMoveAddForm.qty1)
            this.inventoryMoveAddForm.firstNum = this.calculateAllPlanFields(this.inventoryPlanRows.totalFirstNum,this.inventoryPlanRows.totalQty1,this.inventoryMoveAddForm.qty1)
            this.inventoryMoveAddForm.secondNum = this.calculateAllPlanFields(this.inventoryPlanRows.totalSecondNum,this.inventoryPlanRows.totalQty1,this.inventoryMoveAddForm.qty1)
        },  
        // 净重、申报数量、金额、件数2，法一，法二 计算
        calculateAllPlanFields(number,qty1All,qty1Actual){
            if(!number){
                return null
            }else{
                const value = Number(number) || 0;
                const qty1 = Number(qty1All); // 选中数据的件数1
                const planQty1 = Number(qty1Actual); // 填写出库的件数1
                // 计算并保留指定位小数
                const result = (value / qty1) * planQty1;
                const factor = Math.pow(10, 4);  // 10000
                // Number.EPSILON  大约是 2.220446049250313e-16 这是 JavaScript 中最小的正数用于解决浮点数计算中的精度问题
                return Math.round((result + Number.EPSILON) * factor) / factor;  // 加一个极小的数，避免浮点数误差;乘以10^4，将小数变为整数,四舍五入
            }
        },
        // 合并去重方法
        mergeAndDeduplicate(str1, str2) {
            // 处理空值  空值检查：如果两个字符串都是空值（null、undefined、空字符串等）
            if (!str1 && !str2) return '';
                
            // 解析函数
            const parse = (str) => {
                // 字符串空值检查：如果 str 是假值，返回空数组
                if (!str) return [];
                return str.split(',') // 拆分字符串：将逗号分隔的字符串拆分为数组
                    .map(s => s.trim()) // 去除空格：使用 map 遍历数组，对每个元素调用 trim() 去除首尾空格
                    .filter(s => s !== ''); // 过滤空字符串：移除处理后的空字符串
            };
                
                // 解析两个字符串
                const arr1 = parse(str1);
                const arr2 = parse(str2);
                
                // 使用对象去重（比 Set 在某些情况下更快）
                const uniqueMap = {}; // 创建去重映射对象：用于快速检查元素是否已存在
                const result = []; //  创建结果数组
                
                [...arr1, ...arr2].forEach(item => {
                    if (!uniqueMap[item]) { // 检查元素是否已存在
                        uniqueMap[item] = true;
                        result.push(item); // 添加元素到结果数组
                    }
                });
                return result.join(', '); // 将结果数组转换为字符串并返回
        },
        // 多选库存
        inventoryTableRowsCheckbox(){
            const selectedRecords = this.$refs.inventoryTable.getCheckboxRecords();
            this.inventoryTableCheckbox = selectedRecords
        },
        // 批量添加移库计划
        batchAddMovePlan(){
            if(this.inventoryTableCheckbox.length === 0){
                this.$message.error('请选择库存');
            }
            this.inventoryMoveBatchVisible = true
            this.inventoryMoveAddBatchForm.newckName = this.inventoryTableCheckbox[0].ckName
            // 查库区
            this.$api.getStore( this.inventoryMoveAddBatchForm.newckName ).then(res =>{
                this.placeAddList = res
            })

        },
        saveBatchAddInventoryMovePlan(){
            this.$refs.inventoryMoveAddBatchForm.validate((valid) => {
                if (valid) {
                    this.$confirm('是否确认添加移库计划', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        try {
                            var headId =''
                            // 判断是否保存表头，没保存则先保存表头，保存表头后保存表体
                            if( this.inventoryMoveForm.billNo === ''){
                                // 没保存表头情况下直接赋值货主、仓库、提单号、货物名称保存
                                this.inventoryMoveForm.ownerName = '' // 货主.
                                this.inventoryMoveForm.ckName = '' // 仓库
                                this.inventoryMoveForm.blNo = '' // 提单号
                                this.inventoryMoveForm.goodsName = '' // 货物名称
                                // 保存后头id
                                headId = await this.$api.wmsAddStockMoveHead(clean(this.inventoryMoveForm))
                            }else{
                                headId = this.inventoryMoveForm.id
                               // 更新表头仓库、货物、提单号
                            }
                            const newParamsList = this.inventoryTableCheckbox.map(item => {
                                const params = {
                                    taskType:'移库',
                                    rowStatus: '', // 状态   
                                    blNo: item.blNo, // 提单号
                                    interId:headId, // 父id,表头id
                                    goodsType: item.goodsType, // 货物类型
                                    hsCode: item.hsCode, // 海关编码
                                    goodsName: item.goodsName, // 货物名称
                                    spec: item.spec, // 规格型号
                                    ownerName: item.ownerName, // 货主
                                    ckName: item.ckName, // 仓库
                                    place: item.place, // 库区
                                    location: item.location, // 库位
                                    qty1Unit: item.qty1Unit, // 件数1单位
                                    qty2Unit: item.qty2Unit, // 件数2单位
                                    decUnit: item.decUnit, // 申报单位代码
                                    decCurrency: item.decCurrency, // 币制
                                    stockDate:item.createDate ,// 入库日期
                                    originCountry:item.originCountry, // 原产地 
                                    lawUnitFirst: item.lawUnitFirst, // 法一单位
                                    lawUnitSecond: item.lawUnitSecond, // 法二单位
                                    itemNo:item.itemNo, // 项号
                                    boxNo:item.boxNo, // 箱号
                                    skuNo: item.skuNo, // 商品料号
                                    lotNo:item.lotNo,
                                    lotOrderNo:item.lotOrderNo,
                                    lotMaterialNo:item.lotMaterialNo,
                                    lotKgs : item.lotKgs,
                                    originCountryName:item.originCountryName,
                                    totalQty1: item.totalQty1,
                                    totalQty2: item.totalQty2,
                                    totalDecAmount: item.totalDecAmount, // 总价（申报金额）
                                    totalNetWeight: item.totalNetWeight, // 净重
                                    totalDecNum: item.totalDecNum, // 申报数量
                                    totalFirstNum: item.totalFirstNum ? item.totalFirstNum : '', // 法一数
                                    totalSecondNum: item.totalSecondNum ? item.totalSecondNum : '', // 法二数
                                    newCkName : this.inventoryMoveAddBatchForm.newckName,
                                    newLocation :  this.inventoryMoveAddBatchForm.newLocation,
                                    newPlace :  this.inventoryMoveAddBatchForm.newPlace,
                                    decPrice:item.decPrice,
                                    createDate:item.createDate,
                                    cusDeclNo:item.cusDeclNo,
                                    invDecNo:item.invDecNo,
                                    customer:item.customer,
                                    isBonded:item.isBonded,
                                    handbook:item.handbook,
                                    note:item.note,
                                }
                                return clean(params)
                            })
                            await this.$api.wmsAddStockMoveBatch(headId,newParamsList);
                            this.$message.success('保存成功');
                            this.inventoryTableCheckbox = []
                            // 并行执行查询操作
                            await Promise.all([
                                setTimeout(() => {
                                    this.getWMSMoveDetail(headId),
                                    this.inventorySeach()
                                    this.inventoryMoveBatchClose()
                                }, 500),
                            ]);
                        } catch (error) {
                            console.error('批量调用接口失败:', error);
                        }
                    })
                } else {
                    this.$message.error('请填写必填字段')
                    return false;
                }
            });
        },
        // 关闭批量弹窗
        inventoryMoveBatchClose(){
            this.inventoryMoveBatchVisible = false
            this.inventoryMoveAddBatchForm = {
                newckName:'',
                newPlace:'', 
                newLocation:'',
            }
        },
        // 添加移库计划
        async saveAddInventoryMovePlan(){
            // try {
                const valid = await new Promise((resolve) => {
                    this.$refs.inventoryMoveAddForm.validate((valid) => {
                        resolve(valid);
                    });
                });
                if (!valid) {
                    this.$message.error('请填写必填字段');
                    return false;
                }
                var headId =''
                // 判断是否保存表头，没保存则先保存表头，保存表头后保存表体
                if( this.inventoryMoveForm.billNo === ''){
                    // 没保存表头情况下直接赋值货主、仓库、提单号、货物名称保存
                    this.inventoryMoveForm.ownerName = this.inventoryPlanRows.ownerName // 货主.
                    this.inventoryMoveForm.ckName = this.inventoryPlanRows.ckName // 仓库
                    this.inventoryMoveForm.blNo = this.inventoryPlanRows.blNo // 提单号
                    this.inventoryMoveForm.goodsName = this.inventoryPlanRows.goodsName // 货物名称
                    // 保存后头id
                    headId = await this.$api.wmsAddStockMoveHead( this.inventoryMoveForm )
                }else{
                    // await this.$api.wmsGetStockMoveHead( this.inventoryMoveForm.id )
                    headId = this.inventoryMoveForm.id
                    // 保存情况下，更新表头信息，去重
                    // const newCkName = this.mergeAndDeduplicate(
                    //     this.inventoryMoveForm.ckName,
                    //     this.inventoryPlanRows.ckName
                    // );
                    // const newOwnerName = this.mergeAndDeduplicate(
                    //     this.inventoryMoveForm.ownerName,
                    //     this.inventoryPlanRows.ownerName
                    // );
                    // const newBlNo = this.mergeAndDeduplicate(
                    //     this.inventoryMoveForm.blNo,
                    //     this.inventoryPlanRows.blNo
                    // );
                    // const newGoodsName = this.mergeAndDeduplicate(
                    //     this.inventoryMoveForm.goodsName,
                    //     this.inventoryPlanRows.goodsName
                    // );
                    // this.inventoryMoveForm.ownerName = newOwnerName
                    // this.inventoryMoveForm.blNo = newBlNo
                    // this.inventoryMoveForm.goodsName = newGoodsName
                    // this.inventoryMoveForm.ckName = newCkName
                    
                }
                const params = {
                        taskType:'移库',
                        rowStatus: '', // 状态   
                        blNo: this.inventoryPlanRows.blNo, // 提单号
                        interId:headId, // 父id,表头id
                        goodsType: this.inventoryPlanRows.goodsType, // 货物类型
                        hsCode: this.inventoryPlanRows.hsCode, // 海关编码
                        goodsName: this.inventoryPlanRows.goodsName, // 货物名称
                        spec: this.inventoryPlanRows.spec, // 规格型号
                        ownerName: this.inventoryPlanRows.ownerName, // 货主
                        ckName: this.inventoryPlanRows.ckName, // 仓库
                        place: this.inventoryPlanRows.place, // 库区
                        location: this.inventoryPlanRows.location, // 库位
                        qty1Unit: this.inventoryPlanRows.qty1Unit, // 件数1单位
                        qty2Unit: this.inventoryPlanRows.qty2Unit, // 件数2单位
                        // packageType:this.inventorySelected.packageType, // 包装   库存没包装
                        decUnit: this.inventoryPlanRows.decUnit, // 申报单位代码
                        decUnitName: this.inventoryPlanRows.decUnitName,
                        decCurrency: this.inventoryPlanRows.decCurrency, // 币制
                        stockDate:this.inventoryPlanRows.createDate ,// 入库日期
                        createDate:this.inventoryPlanRows.createDate,
                        originCountry:this.inventoryPlanRows.originCountry, // 原产地 库存没有原产地
                        lawUnitFirst: this.inventoryPlanRows.lawUnitFirst, // 法一单位
                        lawUnitFirstName: this.inventoryPlanRows.lawUnitFirstName,
                        lawUnitSecond: this.inventoryPlanRows.lawUnitSecond, // 法二单位
                        itemNo:this.inventoryPlanRows.itemNo, // 项号
                        skuNo: this.inventoryPlanRows.skuNo, // 商品料号
                        decPrice:this.inventoryPlanRows.decPrice, // 单价
                        isBonded:this.inventoryPlanRows.isBonded, // 保税
                        handbook:this.inventoryPlanRows.handbook, // 账册号
                        cusDeclNo:this.inventoryPlanRows.cusDeclNo, 
                        invDecNo:this.inventoryPlanRows.invDecNo,
                        boxNo:this.inventoryPlanRows.boxNo,
                        customer: this.inventoryPlanRows.customer,   
                        stockDateNum: this.inventoryPlanRows.stockDateNum,
                        lotNo:this.inventoryPlanRows.lotNo,
                        lotOrderNo:this.inventoryPlanRows.lotOrderNo,
                        lotMaterialNo:this.inventoryPlanRows.lotMaterialNo,
                        lotKgs : this.inventoryPlanRows.lotKgs,
                        originCountryName:this.inventoryPlanRows.originCountryName,
                        newCkName:this.inventoryMoveAddForm.newckName,
                        newPlace:this.inventoryMoveAddForm.newPlace,
                        newLocation:this.inventoryMoveAddForm.newLocation,
                        totalQty1: this.inventoryMoveAddForm.qty1,
                        totalQty2: this.inventoryMoveAddForm.qty2,
                        totalDecAmount: this.inventoryMoveAddForm.decAmount, // 总价（申报金额）
                        totalNetWeight: this.inventoryMoveAddForm.netWeight, // 净重
                        totalDecNum: this.inventoryMoveAddForm.decNum, // 申报数量
                        totalFirstNum: this.inventoryMoveAddForm.firstNum ? this.inventoryMoveAddForm.firstNum : '', // 法一数
                        totalSecondNum: this.inventoryMoveAddForm.secondNum ? this.inventoryMoveAddForm.secondNum : '', // 法二数
                        note:this.inventoryPlanRows.note,
                    }
                    const paramsArr = []
                    paramsArr.push(clean(params))
                    await this.$api.wmsAddStockMoveBatch(headId,paramsArr);
                    // 刷新页面
                    await this.getWMSMoveDetail(headId)
                    // 刷新库存
                    await this.inventorySeach()
                    // 关闭弹窗
                    await this.inventoryMoveClose();
        },
        // 多选移库计划信息
        movePlanRowsCheckbox(){
            const selectedRecords = this.$refs.inventoryMoveTable.getCheckboxRecords();
            this.movePlanCheckbox = selectedRecords
        },
        // 删除移库计划
        async batchDeleteMovePlan(  ){
            if(this.movePlanCheckbox.length === 0){
                this.$message.error('请选择计划信息');
                return false
            }
            this.$confirm('是否删除此计划?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const params = this.movePlanCheckbox.map(item => item.id)
                this.$api.wmsRemoveDetails(params).then( async res =>{
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                    // 刷新页面
                    await this.getWMSMoveDetail(this.inventoryMoveForm.id)
                    await this.inventorySeach()
                })
            })
        },
        // 更新表头
        async wmsUpdateStockMoveHead(){
            // 更新表头
            var newOwnerName = ''
            var newCkName = ''
            var newBlNo = ''
            var newGoodsName = ''
            if(this.inventoryMovePlanData.length !== 0){
                const newOwnerName = [...new Set(
                    this.inventoryMovePlanData
                        .map(item => item?.ownerName?.trim())  // 提取并清理 ownerName
                        .filter(ownerName => ownerName != null && ownerName !== '')  // 过滤空值
                )].join(', ');
                const newBlNo =  [...new Set(
                    this.inventoryMovePlanData
                        .map(item => item?.blNo?.trim())  // 提取并清理 blNo
                        .filter(blNo => blNo != null && blNo !== '')  // 过滤空值
                )].join(', ');

                const newGoodsName = [...new Set(
                    this.inventoryMovePlanData
                        .map(item => item?.goodsName?.trim())  // 提取并清理 blNo
                        .filter(goodsName => goodsName != null && goodsName !== '')  // 过滤空值
                )].join(', ');

                 const newCkName = [...new Set(
                    this.inventoryMovePlanData
                        .map(item => item?.ckName?.trim())  // 提取并清理 ckName
                        .filter(ckName => ckName != null && ckName !== '')  // 过滤空值
                )].join(', ');
            }
            this.inventoryMoveForm.ownerName = newOwnerName
            this.inventoryMoveForm.blNo = newBlNo
            this.inventoryMoveForm.goodsName = newGoodsName
            this.inventoryMoveForm.ckName = newCkName
            await this.$api.wmsUpdateStockMoveHead( this.inventoryMoveForm )
            // 刷新表头
            await this.getWMSMoveDetail(this.inventoryMoveForm.id)
        },
        // 打开下发暂存弹窗
        inventoryMoveSaveOpTaskTrue(){
            this.inventoryMoveSaveOpTaskForm = {
                storekeeper:'',
                note:'',
            }
            this.inventoryMoveSaveOpTaskVisible = true

        },
        // 关闭弹窗
        inventoryMoveSaveOpTaskClose(){
            this.inventoryMoveSaveOpTaskForm = {
                storekeeper:'',
                note:'',
            }
            this.inventoryMoveSaveOpTaskVisible = false
        },
        // 下发暂存作业单
        inventoryMoveSaveOpTask(){
            //  验证表单
            this.$refs.inventoryMoveSaveOpTaskForm.validate(async (valid) => {
                if (valid) {
                    var params = {}
                    params.taskType = '移库作业'
                    params.interId = this.inventoryMoveForm.id
                    params.createUser = this.inventoryMoveForm.operator
                    params.ckName = this.inventoryMoveForm.ckName
                    params.blNo = this.inventoryMoveForm.blNo
                    params.ownerName = this.inventoryMoveForm.ownerName
                    params.goodsName = this.inventoryMoveForm.goodsName
                    params.note = this.inventoryMoveSaveOpTaskForm.note
                    params.storekeeper = this.inventoryMoveSaveOpTaskForm.storekeeper
                    params.qty1 = this.inventoryMovePlanData.reduce((sum, item) =>  {
                        // 安全地转换为数字
                        const qty = parseFloat(item.qty1);
                        return sum + (isNaN(qty) ? 0 : qty);
                    }, 0);
                    params.netWeight = this.inventoryMovePlanData.reduce((sum, item) => {
                        // 安全地转换为数字
                        const netWeight = parseFloat(item.netWeight);
                        return sum + (isNaN(netWeight) ? 0 : netWeight);
                    }, 0) 
                    params.childList = this.inventoryMovePlanData.map(item => {
                        const { id,interId, workedAmount,workedDecNum,workedFirstNum,workedNetWeight,workedQty1,workedQty2,workedSecondNum,workedVol,
                        completeDate,completeTime,createDate,createTime,rowStatus, ...rest } = item;
                        rest.interId = this.inventoryMoveForm.id // 组合id
                        // 将仓库,报关单号,核注清单号,客户,货主赋值给rest
                        rest.ckName = this.inventoryMoveForm.ckName
                        rest.ownerName = this.inventoryMoveForm.ownerName
                        rest.storekeeper = this.inventoryMoveSaveOpTaskForm.storekeeper
                        return rest;
                    })
                    this.$api.wmsSaveOpTask( params ).then(res =>{
                        this.$message.success('下发成功')
                        // 关闭弹窗
                        this.inventoryMoveSaveOpTaskClose()
                        // 重新查询主任务
                        this.getWMSMoveDetail(this.inventoryMoveForm.id)
                    })
                } else {
                    this.$message.error('请填写必填字段')
                    return false;
                }
            })
        },
        // 查询作业信息
        wmsGetOpsBySubId(id){
            this.$api.wmsGetOpsBySubId(id).then(res =>{
                this.IssueGoodsData = res
            })
        },
        // 删除下发暂存作业
        delIssueRows(row){
            this.$confirm('是否删除此作业任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then( () => {
                this.$api.wmsDeleteJobById(row.id).then(res =>{
                // this.$api.wmsDeleteStockMoveOp(row.id).then(res =>{
                    this.getWMSMoveDetail(this.inventoryMoveForm.id)
                })
            })
        },
        // 下发
        IssueRows(row){
            this.$confirm('是否推送作业任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.wmspushOpTask(row.id).then(res =>{
                    this.$message({
                        type: 'success',
                        message: '推送成功!'
                    });
                    // 更新数据
                    this.wmsGetOpsBySubId(row.interId)
                })
            }).catch(() => {      
            });
        },
        // 完成
        completeRows(row){
            // 打开完成弹窗
            this.viewCompleteworkVisible = true
            this.completeworkRow = row            
        },
        // 关闭查看完成状态下的作业详情
        viewCompleteworkClose(id){
            this.viewCompleteworkVisible = false
            this.completeworkRow = {}
            // 刷新页面
            this.getWMSMoveDetail(this.inventoryMoveForm.id)
        },
        // 查看完成状态下的作业详情
        getCompleteDetails(row){
            this.viewCompleteworkVisible = true
            this.completeworkRow = row
        },
         // 通用查找方法
        findNameByCode(code, list) {
            return findNameByCode(code, list)
        },
         // 打印
        report(command, row){
            // 根据不同的 command 执行不同的打印逻辑
            switch (command) {
                case '存货卡_有标识_保税':
                    this.printCard(row,1);
                    break;
                case '存货卡_有标识_非保税':
                    this.printCard(row,2);
                    break;
                case '存货卡_无标识_保税':
                    this.printCard(row,3);
                    break;
                case '存货卡_无标识_非保税':
                    this.printCard(row,4);
                    break;
                case '存货卡_建发':
                    this.printCard(row,0);
                    break;
                default:
                    this.$message.warning('未知的打印类型');
            }
           
        },
        // 存货卡
        async printCard(row,logo){
            // 判断是否保税
            var reportURL = ''
            if(logo === 1){
                reportURL ='/grf/存货卡_有标识.grf'
            }else if(logo === 2){
                reportURL ='/grf/存货卡_非保有标识.grf'
            }else if(logo === 3){
                reportURL ='/grf/存货卡_无标识.grf'
            }else if(logo === 4){
                reportURL ='/grf/存货卡_非保无标识.grf'
            }else if(logo === 0){
                reportURL ='/grf/存货卡_建发.grf'
            }
            const reports = []
            // 1. 构造报表数组
            row.childList.forEach( item => {
                const singleData = {
                    master: [{
                        goodsName: item.goodsName,
                        spec: item.spec,
                        completeTime: row.createDate,
                        location: item.newLocation,
                        place: item.newPlace,
                        ckName: item.newCkName,
                        ownerName: item.ownerName,
                        invDecNo: item.invDecNo,
                        qty1: item.qty1,
                        qty1UnitName: this.findNameByCode(item.qty1Unit, this.unitList),
                        qty2:item.qty2 ? '/' + item.qty2 : '' ,
                        qty2UnitName: this.findNameByCode(item.qty2Unit, this.unitList),
                        blNo: item.blNo,
                        remark: this.inventoryMoveForm.note ? this.inventoryMoveForm.note : '' + row.note ? row.note :'',
                        boxNo:item.boxNo,
                        truckNo:item.truckNo,
                        itemNo:item.itemNo,
                    }],
                };
                reports.push({
                    report: urlAddRandomNo(reportURL), // 模板路径或JSON
                    data: singleData // 对应的数据
                });
            });
            var args = {
                FontEmbedding: true,
                type: "preview",
            };
            webapp_ws_ajax_together(args,reports);
        },
        
        // 通知父级页面
        notifyParentBeforeUnload(){
            const targetOrigin =  localStorage.getItem('parentOrigin')
            window.opener.postMessage(
                { 
                    type: 'WINDOW_CLOSED',
                    value: true,
                },
                targetOrigin
            );
            // localStorage.clear();
        },
        setupMessageListener() {
            // 监听父页面发送的消息
            window.addEventListener('message', (event) => {
                // 验证消息来源（可选，增加安全性）
                if (event.origin !== window.location.origin) {
                // 如果不是同源消息，可以忽略或处理
                }
                if (event.data.type === 'CLOSE_WINDOW_FROM_PARENT') {
                    window.close();
                }
            });
        },
        // 删除移库任务单
        inventoryMoveDel(){
            this.$confirm('是否确定删除移库任务单？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除
                this.$api.wmsRemoveStockMoveHead(this.inventoryMoveForm.id).then(res =>{
                    this.$message({
                        type: "success",
                        message: '删除成功'
                    })
                    // 关闭此页面（父页面检测到窗口关闭后会刷新盘点作业列表）
                    window.close();
                })
            })
        },
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.notifyParentBeforeUnload)
        
    },
}
</script>
<style style lang="less" scoped>
.width_100{
    width:100%;
}
// 按钮
.buttons_box{
    margin: 5px 15px;
    display: flex;
    align-items: center;
}
.mini_button{
    padding: 3px 8px !important;
}
.inventoryMoveForm{
    margin: 10px;
}
// 表头样式
.inventoryMoveForm .el-col-4{
    padding-left: 8px !important;
    padding-right: 8px !important;
}
.inventoryMoveForm .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
    // margin-bottom: 3px !important;
    margin-right: 5px !important;
}
// 分割线颜色
.el-divider__text{
    color: #797c81 !important;
}
.el-divider--horizontal {
    margin: 10px 0;
}
.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 5px;
}
.mini_button_text{
    padding: 3px 3px !important;
}
.inventorySeachForm .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>